export default {
    ACEITE_TERMOS: 'Aceite de Termos',
    ANEXO_LICITACAO: 'Anexo da Licitação',
    ATA_LICITACAO: 'Ata Licitação',
    CATALOGO: 'Catálogo',
    CERTIDOES_INDICES: 'Certidões e Índices',
    CERCA: 'Cerca',
    CONTRARRAZAO: 'Contrarrazão',
    EDITAL: 'Edital',
    ESCLARECIMENTO: 'Esclarecimento',
    FICHA_TECNICA: 'Ficha Técnica',
    IMPUGNACAO: 'Impugnação',
    PROPOSTA: 'Proposta',
    PROPOSTA_READEQUADA: 'Proposta Readequada',
    PROTOCOLO: 'Protocolo',
    RECURSO: 'Recurso',
    REL_HOMOLOGACAO: 'Relatório de Itens Homologados/Adjudicados',
    RELATORIO_CONTRARRAZAO: 'Relatório de Contrarrazão',
    RELATORIO_RECURSO: 'Relatório de Recurso',
    REL_ESCLARECIMENTO_IMPUGNACAO: 'Relatório Esclarecimento/Impugnação',
    REL_PARTICIPANTES: 'Relatório de Participantes',
    RESPOSTA_CONTRARRAZAO: 'Resposta de Contrarrazão',
    RESPOSTA_ESCLARECIMENTO_INPUGNACAO: 'Resposta de Esclarecimento e Impugnação',
    RESPOSTA_RECURSO: 'Resposta de Recurso',
    TERMO_CREDENCIAMENTO: 'Termo Credenciamento',
    TERMO_HABILITACAO: 'Termo Habilitação',
    ANEXO_FORNECEDOR: 'Anexo do Fornecedor',
    REL_ANALISE_SOLICITACAO_CREDENCIAMENTO: 'Relatório de Análise da Solicitação de Credenciamento',
    REL_FORNECIMENTO_PEDIDO: 'Relatório de Pedido'
}